import rill from "rill";
import set from "@rill/set";

import getPrograms from "./programs.controller";
import getProgramEditor from "./program-editor.controller";
import getWorkout from "./workout.controller";

import ProgramOverview from "./program-overview";
import ProgramPreview from "./program-preview";

const Programs = (app) => {
  app.at(
    "/programs/*",
    rill()
      .use(set("heading", ["Athlete", "Programs"]))
      .setup(ProgramOverview)
      .setup(ProgramPreview)
      .setup((app) => app.get("/", getPrograms))
      .setup((app) => app.get("/edit-program/:cycleId", getProgramEditor))
      .setup((app) => app.get("/workout", getWorkout))
  );
};

export default Programs;
